var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWildflowers = function SvgWildflowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE840",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M16 18.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m13.562 16.756-1.75.569-.15.063a3.125 3.125 0 1 0 4.325 3.124 1.335 1.335 0 0 0 0-.162v-1.788"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m14.512 13.919-1.1-1.519-.106-.119a3.056 3.056 0 0 0-1.362-.9 3.126 3.126 0 1 0-.288 5.982l.156-.038 1.75-.569M16 18.563v1.812a1.296 1.296 0 0 0 0 .163 3.125 3.125 0 1 0 4.325-3.125l-.15-.063-1.75-.569M18.438 16.756l1.75.569.156.038a3.125 3.125 0 1 0-.288-5.982c-.527.171-.998.482-1.362.9-.039.039-.074.08-.106.125l-1.1 1.513"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m17.488 13.919 1.1-1.519c.03-.044.057-.09.08-.138.286-.475.437-1.02.438-1.575a3.125 3.125 0 0 0-6.212 0c0 .555.152 1.1.437 1.575l.082.144 1.1 1.513M16 13.5v-2.081M13.625 15.225l-1.981-.644M14.531 18.025l-1.225 1.681M17.469 18.025l1.225 1.681M18.375 15.225l1.981-.644"
  })));
};
export default SvgWildflowers;